import { Radio, RadioProps } from "@mui/material";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";

const RadioButton = ({ sx, ...otherProps }: RadioProps) => (
    <Radio
        {...otherProps}
        sx={{
            color: (theme) => theme.palette.neutrals.main,
            "&.Mui-checked": {
                color: (theme) =>
                    `linear-gradient(94.61deg, ${theme.palette.button.active.from} 0%, ${theme.palette.button.active.to} 100%)`,
            },
            "& > .MuiSvgIcon-root": {
                fontSize: 13,
            },
            ...sx,
        }}
        icon={<CustomIcon icon={icons.radioButton} />}
        checkedIcon={<CustomIcon icon={icons.radioButtonChecked} />}
    />
);

export default RadioButton;
